export const mapping = JSON.parse(__LOCALE_MAPPING_neb4uau3yzo__);
        export const namespaces = JSON.parse(__LOCALE_NAMESPACES_f90ndbwhpxn__);